"use client";
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";

import { AuthProvider, useAuth } from "./context/AuthContext";
import { SidebarProvider } from "./context/SidebarContext";
import { ConsultationProvider, useConsultation } from "./context/ConsultationContext";
import Sidebar from "./components/Sidebar";
import ConsultationSidebar from "./pages/Clinic/Consultations/components/ConsultationSidebar";
import ConsultationHistorySidebar from "./pages/Clinic/Consultation History/components/ConsultationHistorySidebar";
import TokenExpiryNotification from "./components/TokenExpiryNotification";
import AmmendClaimStatusView from "./pages/Dispensary/AmmendScript/views/AmmendClaimStatusView.jsx";

// Import pages
import { Dashboard } from "./pages/dashboard";
import { BranchTableView } from "./pages/branchManagement";
import { UserManagement, AddUser, EditUser } from "./pages/userManagement";
import { AdminDashboard, ViewPharmacyApp } from "./pages/admin";
// import { AdminDashboard} from "./pages/PharmacyAdmin";
import { DrugStockLevel, TopSellingMedications, InventoryLevels, ExpiredStock as ExpiredStockAnalytics, DemandForecasting, ReturnRate, Descriptive, Predictive, PreEmptive, Prescriptive, Analytics } from "./pages/Analytics";
import { InventoryManagement, InventoryItemDetail, ReceiveStock, ReverseStock, StockTransfer, ExpiredStock,StockRequest } from "./pages/Inventory Managment";
import {EcoControlSensors, EcoControlFridges} from "./pages/EcoControl";
import { Landing } from "./pages/user_menus";
import { FrontShopLanding, FrontShopLogin, AddCustomer, DebtorsView, PaymentTypesView, CashPaymentView, CardPaymentView, CodUnpaidOrdersView, CodPaymentView, CodRefundItemsView, CreditProfilesView, CreditBalanceView, CreditBalanceCompleteView, SplitPaymentStep1View, SplitPaymentStep2View, SplitMedicalAidProfilesView, MedicalAidPaymentView, CompletedOrdersView, CashOrderDetailView, CardOrderDetailView, CodOrderDetailView, CreditOrderDetailView, SplitOrderDetailView, MedicalAidOrderDetailView } from "./pages/frontShopSales";
import { CreditApplication, CreditContact, CreditEmployment, CreditFinancial, CreditConsent, CreditDebtorsList } from "./pages/credits";
import RpDebtors from "./pages/credits/rpdebtors.jsx";
import RpDebtorStatement from "./pages/credits/views/RpDebtorStatement.jsx";
import { Login, Register } from "./pages/auth";
import SupplierManagement from "./pages/Supplier/Supplier Management/views/SupplierManagement";
import SupplierRatings from "./pages/Supplier/Supplier Ratings/views/SupplierRatings";
import { AddBranch, EditBranch } from "./pages/branchManagement";
import CompanyForm from "./pages/companyManagement/views/CompanyForm.jsx";
import {
  ScriptStatistics,
  DoctorStatistics,
  MedicalAidStatistics,
  HealthnetStatistics,
  ScriptTotalsPerMedicalAid,
  HourlyDistribution,
} from "./pages/Dispensary/Reports/index.js";
import {
  DispensaryMenu,
  ScriptMenu,
  CustomerDetailsScript,
  MedicalHistoryTableView,
  MedicaHistoryHistoryDetailsView,
  ScriptHistoryDetailsView,
  OTCHistoryDetailsView,
  ClinicHistoryDetailsView,
  ScriptPaymentSummary,
  MedicationHistory,
  PriceScriptForm,
  AmmendCustomerDetails,
  RewriteScriptFilterPatient,
  FullPatientScriptList,
  FilterAmmendScriptInfo,
  ClaimStatusView,
  PriceScriptSummaryView,
  ClinicScriptCustomerDetails,
  ClinicScriptPatientDetails,
  ClinicScriptDetails,
  PriceScriptPaymentSummary,
  LabelConfiguration,
  ChronicMedication,
  ChronicMedicationQuickView, OTCCustomerD, DispenseTable, OTCpatientScriptInfo, ToFollowsList, TotalOutStanding, AmmendNewScript, AmmendScriptPaymentSummary, MedicalAidAmmendFilter, PatientScriptInfoFull, OTCMedication, OTCPaymentSummary,
  ChronicScriptView,
  PackageScript,
  PackageScriptQuickView,
  PackageScriptView
} from "./pages/Dispensary";

import { FilterPatientScript, NewScriptForm, PatientScriptInfo, ClaimApprovedTable } from "./pages/global";
import CustomerDetails from "./pages/global/view/customer-detailsForm.jsx";

import {
  CollectionAndDeliveryMenu,
  CollectionDetails,
  DeliveryDetails,
  DeliveryView,
} from "./pages/Dispensary/Collection-and-Delivery";
import GenericDictionary from "./pages/Dispensary/AdditionalInformation/views/GenericDictionary.jsx";
import DOHGuideline from "./pages/DOHGuideline/views/DOHGuideline.jsx";
import DOHGuidelineViewMore from "./pages/DOHGuideline/views/DOHGuidelineViewMore.jsx";

// Driver pages
import { DriverDashboard, DriverRoutePlan, DriverInTransit, DriverCompletedDelivery, DriverRouteGuard } from "./pages/Driver";

import Clinic from "./pages/Clinic/Booking/views/Clinic.jsx";
import ViewAllAppointments from "./pages/Clinic/Booking/components/ViewAllAppointments.jsx";
import ConsultationHistory from "./pages/Clinic/Consultation History";
import ConsultationHistoryDetails from "./pages/Clinic/Consultation History/views/ConsultationHistoryDetails.jsx";
import ConsultationHistoryServiceDetails from "./pages/Clinic/Consultation History/views/ConsultationHistoryServiceDetails.jsx";
import ServicesDone from "./pages/Clinic/Consultation History/views/ServicesDone.jsx";
import MedicalHistory from "./pages/Clinic/Consultation History/views/MedicalHistory.jsx";
import TreatmentHistory from "./pages/Clinic/Consultation History/views/TreatmentHistory.jsx";
import ImmunizationHistory from "./pages/Clinic/Consultation History/views/ImmunizationHistory.jsx";
import {ProfileMenu, MergeProfileTable, ProfileDetails, SplitProfileTable, SplitProfile, CompleteSplitProfile,AddDoctor} from "./pages/Profiles";
import { CreateProfile } from "./pages/Profiles/Create";
import { UpdateProfile } from "./pages/Profiles/Update";
import BloodPressure from "./pages/Clinic/Consultations/TreatmentTypes/BloodPressure";
import GlucoseTest from "./pages/Clinic/Consultations/TreatmentTypes/GlucoseTest";
import CholesterolTest from "./pages/Clinic/Consultations/TreatmentTypes/Cholesterol";
import Lipogram from "./pages/Clinic/Consultations/TreatmentTypes/Lipogram";
import PeakFlow from "./pages/Clinic/Consultations/TreatmentTypes/PeakFlow";
import UrineDipstick from "./pages/Clinic/Consultations/TreatmentTypes/UrineDipstick";
import Hemoglobin from "./pages/Clinic/Consultations/TreatmentTypes/Hemoglobin";
import HIV from "./pages/Clinic/Consultations/TreatmentTypes/HIV";
import EarSyringing from "./pages/Clinic/Consultations/TreatmentTypes/EarSyringing";
import Woundcare from "./pages/Clinic/Consultations/TreatmentTypes/WoundCare.jsx";
import Injection from "./pages/Clinic/Consultations/TreatmentTypes/Injection.jsx";
import Nebulisation from "./pages/Clinic/Consultations/TreatmentTypes/Nebulisation.jsx";
import PapSmear from "./pages/Clinic/Consultations/TreatmentTypes/PapSmear.jsx";
import FamilyPlanningConsent from "./pages/Clinic/Consultations/views/Consent_forms/FamilyPlanning.jsx";
import FamilyPlanning from "./pages/Clinic/Consultations/TreatmentTypes/FamilyPlanning.jsx";
import BabyImmunization from "./pages/Clinic/Consultations/TreatmentTypes/BabyImmunization.jsx";
import DietConsultWeekly from "./pages/Clinic/Consultations/TreatmentTypes/DietConsultWeekly.jsx";
import DietPlusInjection from "./pages/Clinic/Consultations/TreatmentTypes/DietPlusInjection.jsx";
import DiabetesConsult from "./pages/Clinic/Consultations/TreatmentTypes/DiabetesConsult.jsx";
import HealthRiskAssessment from "./pages/Clinic/Consultations/TreatmentTypes/HealthRiskAssessment.jsx";
import MetabolicConsult from "./pages/Clinic/Consultations/TreatmentTypes/MetabolicConsult.jsx";
import MomentumHRA from "./pages/Clinic/Consultations/MedicalAidTreatments/MomentumHRA.jsx";
import DiscoveryVitality from "./pages/Clinic/Consultations/MedicalAidTreatments/DiscoveryVitality.jsx";
import WellnessScreening from "./pages/Clinic/Consultations/MedicalAidAssociations/WellnessScreening.jsx";

import { Consultations, ConsultationDetails, ClinicMenu, PatientOverview } from "./pages/Clinic/index.js";
import MedicalSocialHistory from "./pages/Clinic/Consultations/views/MedicalSocialHistory.jsx";
import VitalsObservations from "./pages/Clinic/Consultations/views/VitalsObservations.jsx";
import SymptomsExam from "./pages/Clinic/Consultations/views/SymptomsExam.jsx";
import SpecializedTests from "./pages/Clinic/Consultations/views/SpecializedTests.jsx";
import DiagnosisICD10 from "./pages/Clinic/Consultations/views/DiagnosisICD10.jsx";
import ProblemList from "./pages/Clinic/Consultations/views/ProblemList.jsx";
import TreatmentPlan from "./pages/Clinic/Consultations/views/TreatmentPlan.jsx";
import Prescription from "./pages/Clinic/Consultations/views/Prescription.jsx";
import ReviewFollowUp from "./pages/Clinic/Consultations/views/ReviewFollowUp.jsx";
import Invoice from "./pages/Clinic/Consultations/views/Invoice.jsx";
import  ClinicServices  from "./pages/Clinic/ClinicServices/views/ClinicServices.jsx";
import InjectionAdministration from "./pages/Clinic/Consultations/views/Consent_forms/InjectionAdministration.jsx";
import CardiometabolicScreening from "./pages/Clinic/Consultations/views/Consent_forms/CardiometabolicScreening.jsx";
import AdultVacination from "./pages/Clinic/Consultations/views/Consent_forms/AdultVacination.jsx";
import MinorVaccination from "./pages/Clinic/Consultations/views/Consent_forms/MinorVaccination.jsx";

import ClinicScriptInvoice from "./pages/Dispensary/ClinicScript/views/ClinicScriptInvoice.jsx";

// CSS Imports
import "./css/components.css";
import "./css/layout.css";

import CreditAccounts from "./pages/frontShopSales/debtors/views/CreditAccounts/CreditAccounts.jsx";
import CODAccounts from "./pages/frontShopSales/debtors/views/CODTransactions/CODAccounts.jsx";
import CODPayment from "./pages/frontShopSales/debtors/views/CODTransactions/CODPayment.jsx";
import DebtorsTransactionList from "./pages/frontShopSales/debtors/views/Transactions/DebtorsTransactionList.jsx";
import DebtorsAccountOptions from "./pages/frontShopSales/debtors/views/Transactions/TransactionOptions/DebtorsAccountOptions.jsx";
import DebtorsInvoice from "./pages/frontShopSales/debtors/views/Transactions/TransactionOptions/Invoices/DebtorsInvoice.jsx";
import DebtorsAccountSummary from "./pages/frontShopSales/debtors/views/Transactions/TransactionOptions/AccountSummary/DebtorsAccountSummary.jsx";
import DebtorsAccountStatement from "./pages/frontShopSales/debtors/views/Transactions/TransactionOptions/Statements/DebtorsAccountStatement.jsx";

function ContentWrapper() {
  const location = useLocation();
  const { user } = useAuth();
  const { isInConsultation } = useConsultation();
  const roleId = Number(user?.roleid);
  const profilesAllowedRoles = [2, 3, 6, 8];

  const isConsentRoute = location.pathname.startsWith("/customer/clinic/consent/");

  const hideConsultationSidebar = location.pathname === "/customer/clinic/invoice";

  const hideGlobalSidebar = location.pathname.startsWith("/customer/dispensary/reports");

  const showSidebar = !hideGlobalSidebar && [
    "/dashboard",
    "/branch-management",
    "/user-management",
    "/add-user",
    "/add-branch",
    "/edit-user",
    "/edit-branch",
    "/company-management",
    "/customer/dispensary",
    "/medical-history",
    "/dispensary",
    // Pharmacy Admin areas
    "/inventory",
    "/supplier-management",
    "/supplier-ratings",
    "/analytics",
    "/customer/profile",
    "/customer/profiles",
    "/Profiles",
    "/customer/clinic",
    "/customer/clinic/services",
    "/credits/debtors",
    "/credits/rpdebtors",
  ].some((prefix) => location.pathname.startsWith(prefix));

  const isInConsultationHistory = location.pathname.includes("/customer/clinic/consultation-history/") && 
    location.pathname !== "/customer/clinic/consultation-history";

  const isLanding = location.pathname === "/";

  return (
    // Only apply layout styles if NOT on Landing
    <div className={isLanding ? "" : "layout-wrapper"}>
      <div className="app-container" style={{ display: "flex" }}>
        {isConsentRoute ? null : isInConsultation ? (
          hideConsultationSidebar ? null : <ConsultationSidebar />
        ) : isInConsultationHistory ? (
          <ConsultationHistorySidebar />
        ) : (
          showSidebar && <Sidebar />
        )}
        <div className="content-area" style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/credits" element={<CreditApplication />} />
            <Route path="/credits/debtors" element={<CreditDebtorsList />} />
            <Route path="/credits/rpdebtors" element={<RpDebtors />} />
            <Route path="/credits/rpdebtors/:profileNo" element={<RpDebtorStatement />} />
            <Route path="/credits/contact" element={<CreditContact />} />
            <Route path="/credits/employment" element={<CreditEmployment />} />
            <Route path="/credits/financial" element={<CreditFinancial />} />
            <Route path="/credits/consent" element={<CreditConsent />} />
            <Route path="/frontshop" element={<FrontShopLanding />} />
            <Route path="/frontshop/login" element={<FrontShopLogin />} />
            <Route path="/frontshop/orders" element={<CompletedOrdersView />} />
            <Route path="/frontshop/orders/cash" element={<CashOrderDetailView />} />
            <Route path="/frontshop/orders/card" element={<CardOrderDetailView />} />
            <Route path="/frontshop/orders/cod" element={<CodOrderDetailView />} />
            <Route path="/frontshop/orders/credit" element={<CreditOrderDetailView />} />
            <Route path="/frontshop/orders/split" element={<SplitOrderDetailView />} />
            <Route path="/frontshop/orders/medical-aid" element={<MedicalAidOrderDetailView />} />
            <Route path="/frontshop/add-customer" element={<AddCustomer />} />
            <Route path="/frontshop/debtors" element={<DebtorsView />} />
            <Route path="/frontshop/debtors/credit-accounts" element={<CreditAccounts />} />
            <Route path="/frontshop/debtors/cod-accounts" element={<CODAccounts />} />
            <Route path="/frontshop/debtors/cod-accounts/payment" element={<CODPayment />} />
            <Route path="/frontshop/debtors/transactions" element={<DebtorsTransactionList />} />
            <Route path="/frontshop/debtors/transactions/options" element={<DebtorsAccountOptions />} />
            <Route path="/frontshop/debtors/transactions/options/invoices" element={<DebtorsInvoice />} />
            <Route path="/frontshop/debtors/transactions/options/account-summary" element={<DebtorsAccountSummary />} />
            <Route path="/frontshop/debtors/transactions/options/statements" element={<DebtorsAccountStatement />} />
            <Route path="/frontshop/payment-types" element={<PaymentTypesView />} />
            <Route path="/frontshop/debtors/payment-types" element={<PaymentTypesView />} />
            <Route path="/frontshop/payment-types/cash" element={<CashPaymentView />} />
            <Route path="/frontshop/debtors/payment-types/cash" element={<CashPaymentView />} />
            <Route path="/frontshop/payment-types/card" element={<CardPaymentView />} />
            <Route path="/frontshop/debtors/payment-types/card" element={<CardPaymentView />} />
            <Route path="/frontshop/payment-types/cod" element={<CodUnpaidOrdersView />} />
            <Route path="/frontshop/payment-types/cod/options" element={<CodUnpaidOrdersView />} />
            <Route path="/frontshop/payment-types/cod/payment" element={<CodPaymentView />} />
            <Route path="/frontshop/payment-types/cod/refund-items" element={<CodRefundItemsView />} />
            <Route path="/frontshop/payment-types/credit" element={<CreditProfilesView />} />
            <Route path="/frontshop/payment-types/credit/balance" element={<CreditBalanceView />} />
            <Route path="/frontshop/payment-types/credit/balance/complete" element={<CreditBalanceCompleteView />} />
            <Route path="/frontshop/payment-types/split" element={<SplitPaymentStep1View />} />
            <Route path="/frontshop/payment-types/split/step2" element={<SplitPaymentStep2View />} />
            <Route path="/frontshop/payment-types/split/medical-aid/profiles" element={<SplitMedicalAidProfilesView />} />
            <Route path="/frontshop/payment-types/split/medical-aid/payment" element={<MedicalAidPaymentView />} />
            <Route path="/frontshop/payment-types/split/method1=cash" element={<CashPaymentView />} />
            <Route path="/frontshop/payment-types/split/method1=card" element={<CardPaymentView />} />
            <Route path="/frontshop/payment-types/split/method1=nedbank" element={<CardPaymentView />} />
            <Route path="/frontshop/payment-types/split/method1=ikhokha" element={<CardPaymentView />} />
            <Route path="/frontshop/payment-types/split/method1=cod" element={<CodUnpaidOrdersView />} />
            <Route path="/frontshop/payment-types/split/method1=credit" element={<CreditProfilesView />} />
            <Route path="/frontshop/payment-types/split/step2/method2=cash" element={<CashPaymentView />} />
            <Route path="/frontshop/payment-types/split/step2/method2=card" element={<CardPaymentView />} />
            <Route path="/frontshop/payment-types/split/step2/method2=nedbank" element={<CardPaymentView />} />
            <Route path="/frontshop/payment-types/split/step2/method2=ikhokha" element={<CardPaymentView />} />
            <Route path="/frontshop/payment-types/split/step2/method2=cod" element={<CodUnpaidOrdersView />} />
            <Route path="/frontshop/payment-types/split/step2/method2=credit" element={<CreditProfilesView />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/branch-management" element={<BranchTableView />} />
            <Route path="/add-branch" element={<AddBranch />} />
            <Route path="/edit-branch" element={<EditBranch />} />
            <Route path="/company-management" element={<CompanyForm />} />
            <Route path="/add-user" element={<AddUser />} />
            <Route path="/edit-user" element={<EditUser />} />
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/AdminDashboard" element={<AdminDashboard />} />
            <Route path="/view-pharmacy-app" element={<ViewPharmacyApp />} />
            {/** Removed /view-pharmacy-app route until the component exists */}
            <Route path="/customer/dispensary" element={<DispensaryMenu />} />
            <Route path="/customer/dispensary/reports/script-statistics" element={<ScriptStatistics />} />
            <Route path="/customer/dispensary/reports/doctor-statistics" element={<DoctorStatistics />} />
            <Route path="/customer/dispensary/reports/medical-aid-statistics" element={<MedicalAidStatistics />} />
            <Route path="/customer/dispensary/reports/healthnet-statistics" element={<HealthnetStatistics />} />
            <Route
              path="/customer/dispensary/reports/script-totals-per-medical-aid"
              element={<ScriptTotalsPerMedicalAid />}
            />
            <Route path="/customer/dispensary/reports/hourly-distribution" element={<HourlyDistribution />} />
            <Route path="/customer/dispensary/script" element={<ScriptMenu />} />
            <Route path="/customer/dispensary/script/customer-details" element={<CustomerDetailsScript />} />
            <Route path="/customer/dispensary/new-script" element={<NewScriptForm />} />
            <Route path="/customer/dispensary/script/:scriptNo" element={<PatientScriptInfo />} />
            <Route path="/customer/dispensary/script/details/:scriptNo" element={<PatientScriptInfoFull />} />
            <Route path="/customer/dispensary/medication-history/:patientId" element={<MedicationHistory />} />
            <Route path="/customer/dispensary/price-script" element={<PriceScriptForm />} />
            <Route path="/customer/dispensary/price-script-summary" element={<PriceScriptSummaryView />} />
            <Route path="/customer/dispensary/script/submit-claim/customer-details" element={<CustomerDetails actionButtonLabel="View" showAddPatientButton={true} familyModalOnView={true} />} />
            <Route path="/customer/dispensary/price-script-payment-summary" element={<PriceScriptPaymentSummary />} />
            <Route path="/customer/dispensary/additional-information/generics-dictionary" element={<GenericDictionary />} />
            <Route path="/customer/dispensary/otcCustomer" element={<OTCCustomerD />} />
            <Route path="/customer/dispensary/otc-direct/dispense-table" element={<DispenseTable />} />
            <Route path="/customer/dispensary/otc-direct/medication" element={<OTCMedication />} />
            <Route path="/customer/dispensary/otc-direct/payment-summary" element={<OTCPaymentSummary />} />
            <Route path="/customer/dispensary/to-follows" element={<ToFollowsList />} />
            <Route path="/customer/dispensary/to-follows/total-outstanding" element={<TotalOutStanding />} />
            <Route path="/customer/dispensary/amend-script/new-script" element={<AmmendNewScript />} />
            <Route path="/customer/dispensary/amend-script/payment-summary" element={<AmmendScriptPaymentSummary />} />
            <Route path="/customer/dispensary/otc-direct/dispense/:scriptNo" element={<OTCpatientScriptInfo />} />
            <Route path="/customer/dispensary/amend-script/:scriptNo" element={<FilterAmmendScriptInfo />} />
            {/* Clinic Booking */}
            <Route path="/customer/clinic/booking" element={<Clinic />} />
            <Route path="/customer/clinic/booking/appointments" element={<ViewAllAppointments />} />
          
            <Route path="/customer/clinic/consultation-history" element={<ConsultationHistory />} />
            <Route path="/customer/clinic/consultation-history/:id" element={<ConsultationHistoryDetails />} />
            <Route path="/customer/clinic/consultation-history/:id/service/:serviceId" element={<ConsultationHistoryServiceDetails />} />
            <Route path="/customer/clinic/consultation-history/:id/services-done" element={<ServicesDone />} />
            <Route path="/customer/clinic/consultation-history/:id/medical-history" element={<MedicalHistory />} />
            <Route path="/customer/clinic/consultation-history/:id/treatment-history" element={<TreatmentHistory />} />
            <Route path="/customer/clinic/consultation-history/:id/immunizations" element={<ImmunizationHistory />} />
            {/* Clinic DoH Guideline */}
            <Route path="/customer/clinic/doh-guideline" element={<DOHGuideline />} />
            <Route path="/customer/clinic/doh-guideline/family-planning" element={<DOHGuidelineViewMore />} />
            <Route path="/customer/clinic/services" element={<ClinicServices />} />
            <Route
              path="/medical-history/medical-history-details/script-history-details"
              element={(
                <ScriptHistoryDetailsView
                  usePrescriptionPaymentDelivery={true}
                  readOnlyDelivery={true}
                  forceHideLabelButtons={true}
                />
              )}
            />
            <Route
              path="/medical-history/medical-history-details/otc-history-details"
              element={(
                <OTCHistoryDetailsView
                  usePrescriptionPaymentDelivery={true}
                  readOnlyDelivery={true}
                  forceHideLabelButtons={true}
                />
              )}
            />  
            
            <Route path="/dispensary/label-configuration" element={<LabelConfiguration />} />
            <Route path="/customer/dispensary/script/payment-summary/label-configuration" element={<LabelConfiguration />} />
            <Route path="/customer/dispensary/ammend-script" element={<AmmendCustomerDetails />} />
            <Route path="/customer/dispensary/script/customer-details/:profileNo/rewrite-patient-script" element={<RewriteScriptFilterPatient />} />
            <Route path="/customer/dispensary/script/customer-details/:profileNo/filter-patient-script" element={<FullPatientScriptList />} />
            <Route path="/customer/dispensary/amend-script/claim-status/:scriptNo" element={<AmmendClaimStatusView />} />
            <Route path="/customer/dispensary/script/claim-status" element={<ClaimStatusView />} />
            <Route path="/customer/dispensary/claim-approved" element={<ClaimApprovedTable />} />
            <Route path="/customer/dispensary/clinic-script" element={<ClinicScriptCustomerDetails />} />
            <Route path="/customer/dispensary/clinic-script/:profileNo/details" element={<ClinicScriptPatientDetails />} />
            <Route path="/customer/dispensary/clinic-script/details/:scriptNo" element={<ClinicScriptDetails />} />
            <Route path="/customer/dispensary/clinic-script/invoice/:scriptNo" element={<ClinicScriptInvoice />} />
            <Route path="/customer/dispensary/medical-aid-ammend-filter/:scriptNo" element={<MedicalAidAmmendFilter />} />
            <Route path="/customer/dispensary/script/payment-summary" element={<ScriptPaymentSummary />} />
            <Route path="/dispensary/collection-and-delivery" element={<CollectionAndDeliveryMenu />} />
            <Route path="/dispensary/collection-and-delivery/collection-details" element={<CollectionDetails />} />
            <Route path="/dispensary/collection-and-delivery/delivery-details" element={<DeliveryDetails />} />
            <Route path="/dispensary/collection-and-delivery/delivery/:orderId" element={<DeliveryView />} />
            <Route path="/medical-history" element={<MedicalHistoryTableView />} />
            <Route path="/medical-history/medical-history-details" element={<MedicaHistoryHistoryDetailsView />} /> 
            <Route path="/medical-history/medical-history-details/clinic-history-details" element={<ClinicHistoryDetailsView />} />
            <Route
              path="/medical-history/medical-history-details/script-history-details/:scriptNo"
              element={(
                <ScriptHistoryDetailsView
                  usePrescriptionPaymentDelivery={true}
                  readOnlyDelivery={true}
                  forceHideLabelButtons={true}
                />
              )}
            />
            <Route
              path="/medical-history/medical-history-details/otc-history-details/:otcId"
              element={(
                <OTCHistoryDetailsView
                  usePrescriptionPaymentDelivery={true}
                  readOnlyDelivery={true}
                  forceHideLabelButtons={true}
                />
              )}
            />  
            
            {/* Pharmacy Admin: Inventory Management routes */}
            <Route path="/inventory" element={<InventoryManagement />} />
            <Route path="/inventory/receive-stock" element={<ReceiveStock />} />
            <Route path="/inventory/reverse-stock" element={<ReverseStock />} />
            <Route path="/inventory/reverse-stock/:scriptNo" element={<ReverseStock />} />
            <Route path="/inventory/stock-transfer" element={<StockTransfer />} />
            <Route path="/inventory/stock-request" element={<StockRequest />} />
            <Route path="/inventory/expired-stock" element={<ExpiredStock />} />
            <Route path="/inventory/eco-control-sensors" element={<EcoControlSensors />} />
            <Route path="/inventory/eco-control-sensors/:sectionSlug/:metricSlug" element={<EcoControlSensors />} />
            <Route path="/inventory/eco-control-fridges" element={<EcoControlFridges />} />
            {/* Optional detail route if used elsewhere */}
            <Route path="/inventory/item/:itemId" element={<InventoryItemDetail />} />
            <Route path="/supplier-management" element={<SupplierManagement />} />
            <Route path="/supplier-management/new" element={<SupplierManagement />} />
            <Route path="/supplier-management/:supplierCode/edit" element={<SupplierManagement />} />
            <Route path="/supplier-ratings" element={<SupplierRatings />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/analytics/drug-stock-level" element={<DrugStockLevel />} />
            <Route path="/analytics/top-selling-medications" element={<TopSellingMedications />} />
            <Route path="/analytics/inventory-levels" element={<InventoryLevels />} />
            <Route path="/analytics/expired-stock" element={<ExpiredStockAnalytics />} />
            <Route path="/analytics/demand-forecasting" element={<DemandForecasting />} />
            <Route path="/analytics/return-rate" element={<ReturnRate />} />
            <Route
              path="/customer/profiles"
              element={profilesAllowedRoles.includes(roleId) ? <ProfileMenu /> : <Navigate to="/dashboard" replace />}
            />
            <Route
              path="/customer/profiles/merge-profiles"
              element={profilesAllowedRoles.includes(roleId) ? <MergeProfileTable /> : <Navigate to="/dashboard" replace />}
            />
            <Route
              path="/customer/profile/profile-details"
              element={profilesAllowedRoles.includes(roleId) ? <ProfileDetails /> : <Navigate to="/dashboard" replace />}
            />
            <Route
              path="/customer/profiles/split-profiles"
              element={profilesAllowedRoles.includes(roleId) ? <SplitProfileTable /> : <Navigate to="/dashboard" replace />}
            />
            <Route
              path="/customer/profile/split-profile"
              element={profilesAllowedRoles.includes(roleId) ? <SplitProfile /> : <Navigate to="/dashboard" replace />}
            />
            <Route
              path="/customer/profile/complete-split-profile"
              element={profilesAllowedRoles.includes(roleId) ? <CompleteSplitProfile /> : <Navigate to="/dashboard" replace />}
            />
            <Route
              path="/customer/profile/create"
              element={profilesAllowedRoles.includes(roleId) ? <CreateProfile /> : <Navigate to="/dashboard" replace />}
            />
            <Route
              path="/customer/profile/update"
              element={profilesAllowedRoles.includes(roleId) ? <UpdateProfile /> : <Navigate to="/dashboard" replace />}
            />
            <Route
              path="/Profiles/add-doctor"
              element={profilesAllowedRoles.includes(roleId) ? <AddDoctor /> : <Navigate to="/dashboard" replace />}
            />

            <Route path="/customer/dispensary/chronic-medication" element={<ChronicMedication />} />
            <Route path="/customer/dispensary/chronic-medication-quick-view/:patientId" element={<ChronicMedicationQuickView />} />
            <Route path="/customer/dispensary/chronic-script-view" element={<ChronicScriptView />} />
            <Route path="/customer/dispensary/package-script" element={<PackageScript />} />
            <Route path="/customer/dispensary/package-script-quick-view/:patientId" element={<PackageScriptQuickView />} />
            <Route path="/customer/dispensary/package-script-view" element={<PackageScriptView />} />

            {/* Clinic routes */}
            <Route path="/customer/clinic/consultations" element={<Consultations />} />
            <Route path="/customer/clinic/consultation-details" element={<ConsultationDetails />} />
            <Route path="/customer/clinic/consent/injection-administration" element={<InjectionAdministration />} />
            <Route path="/customer/clinic/consent/cardiometabolic-screening" element={<CardiometabolicScreening />} />
            <Route path="/customer/clinic/consent/vaccination-adult" element={<AdultVacination />} />
            <Route path="/customer/clinic/consent/family-planning" element={<FamilyPlanningConsent />} />
            <Route path="/customer/clinic/family-planning" element={<FamilyPlanning />} />
            <Route path="/customer/clinic/consent/vaccination-minor" element={<MinorVaccination />} />
            <Route path="/customer/clinic/patient-overview" element={<PatientOverview />} />
            <Route path="/customer/clinic/medical-social-history" element={<MedicalSocialHistory />} />
            <Route path="/customer/clinic/vitals-observations" element={<VitalsObservations />} />
            <Route path="/customer/clinic/symptoms-exam" element={<SymptomsExam />} />
            <Route path="/customer/clinic/specialized-tests" element={<SpecializedTests />} />
            <Route path="/customer/clinic/diagnosis-icd10" element={<DiagnosisICD10 />} />
            <Route path="/customer/clinic/problem-list" element={<ProblemList />} />
            <Route path="/customer/clinic/treatment-plan" element={<TreatmentPlan />} />
            <Route path="/customer/clinic/prescription" element={<Prescription />} />
            <Route path="/customer/clinic/review-follow-up" element={<ReviewFollowUp />} />
            <Route path="/customer/clinic/invoice" element={<Invoice />} />
            <Route path="/customer/clinic" element={<ClinicMenu />} />
            <Route path="/customer/clinic/blood-pressure-test" element={<BloodPressure />} />
            <Route path="/customer/clinic/glucose-test" element={<GlucoseTest />} />
            <Route path="/customer/clinic/cholesterol-test" element={<CholesterolTest />} />
            <Route path="/customer/clinic/lipogram-test" element={<Lipogram />} />
            <Route path="/customer/clinic/peak-flow-test" element={<PeakFlow />} />
            <Route path="/customer/clinic/urine-dipstick-test" element={<UrineDipstick />} />
            <Route path="/customer/clinic/hemoglobin-test" element={<Hemoglobin />} />
            <Route path="/customer/clinic/hiv-test" element={<HIV />} />
            <Route path="/customer/clinic/ear-syringing" element={<EarSyringing />} />
            <Route path="/customer/clinic/wound-care" element={<Woundcare />} />
            <Route path="/customer/clinic/injection" element={<Injection />} />
            <Route path="/customer/clinic/nebulisation" element={<Nebulisation />} />
            <Route path="/customer/clinic/pap-smear" element={<PapSmear />} />
            <Route path="/customer/clinic/baby-immunization" element={<BabyImmunization />} />
            <Route path="/customer/clinic/diet-consult-weekly" element={<DietConsultWeekly />} />
            <Route path="/customer/clinic/diet-plus-injection" element={<DietPlusInjection />} />
            <Route path="/customer/clinic/diabetes-consult" element={<DiabetesConsult />} />
            <Route path="/customer/clinic/health-risk-assessment" element={<HealthRiskAssessment />} />
            <Route path="/customer/clinic/metabolic-consult" element={<MetabolicConsult />} />
            <Route path="/customer/clinic/momentum-hra" element={<MomentumHRA />} />
            <Route path="/customer/clinic/discovery-vitality" element={<DiscoveryVitality />} />
            <Route path="/customer/clinic/wellness-screening" element={<WellnessScreening />} />
            {/* Driver routes — gated on the driver role (server enforces it too) */}
            <Route element={<DriverRouteGuard />}>
              <Route path="/driver" element={<DriverDashboard />} />
              <Route path="/driver/route/:jobId" element={<DriverRoutePlan />} />
              <Route path="/driver/in-transit/:jobId" element={<DriverInTransit />} />
              <Route path="/driver/completed/:jobId" element={<DriverCompletedDelivery />} />
            </Route>
          </Routes>
        </div>
      </div>
    </div>
  );
}

function App() {
  React.useEffect(() => {
  }, []);

  return (
    <AuthProvider>
      <SidebarProvider initialActive="Dashboard">
        <ConsultationProvider>
          <Router>
            <div className="container">
              <TokenExpiryNotification />
              <ContentWrapper />
            </div>
          </Router>
        </ConsultationProvider>
      </SidebarProvider>
    </AuthProvider>
  );
}

export default App;